import { render } from "./DialogColorList.vue?vue&type=template&id=58caab9e"
import script from "./DialogColorList.vue?vue&type=script&lang=js"
export * from "./DialogColorList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__